import * as React from "react";
import type { SVGProps } from "react";
const SvgTomorrowland = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#tomorrowland_svg__a)">
      <path d="M11.63 4.14a4.08 4.08 0 0 0-3.74 2.09s.21.69 1.74 1.7a4.1 4.1 0 0 1 2 2.43 4.14 4.14 0 0 1 2-2.43c1.53-1 1.74-1.7 1.74-1.7a4.08 4.08 0 0 0-3.74-2.09m0 3.65a4.66 4.66 0 0 1-3-1.56 3.65 3.65 0 0 1 3-1.55 3.67 3.67 0 0 1 3 1.55 4.7 4.7 0 0 1-3 1.56" />
      <path d="M11.63 4.91a1.34 1.34 0 1 0 .04 2.68 1.34 1.34 0 0 0-.04-2.68m-.3 1.53a.48.48 0 0 1-.47-.44.47.47 0 0 1 .46-.48.46.46 0 0 1 .46.48.47.47 0 0 1-.46.49" />
      <path d="M5.96 5.74a8.66 8.66 0 0 1 11.33 0q.3-.276.56-.59a3.34 3.34 0 0 1-.75-1.92 2.65 2.65 0 0 1-2.3.11l-.28-.09A6.14 6.14 0 0 1 11.63 1a6 6 0 0 1-2.95 2.26l-.15.05a2.72 2.72 0 0 1-2.39-.08 3.3 3.3 0 0 1-.74 1.91q.256.322.56.6M20.29 12.17v.13a8.67 8.67 0 0 1-17.33 0v-.14a5.6 5.6 0 0 1-.72-.89q-.096.732-.1 1.47c0 7.54 9.49 10.26 9.49 10.26s9.49-2.93 9.49-10.26a12 12 0 0 0-.1-1.46q-.314.482-.72.89" />
      <path d="M9.43 8.73c-1.67-1.08-4.88-2.84-5-4.55-6.94 7.22 3.1 10 3.1 10s-2.21.47-2.21 2C5.33 18.86 9.15 20 9.15 20s2.22-.72 2.22-6.41c0-2.5-.39-3.87-1.94-4.86M13.82 8.73c1.68-1.08 4.88-2.84 5-4.55 6.94 7.22-3.09 10-3.09 10s2.21.47 2.21 2c0 2.64-3.83 3.78-3.83 3.78s-2.22-.72-2.22-6.41c0-2.5.4-3.87 1.94-4.86" />
    </g>
    <defs>
      <clipPath id="tomorrowland_svg__a">
        <path fill="#fff" d="M2 1h19.26v22H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTomorrowland;
